import AlexStates from 'a/components/GameHeader/AlexStates';
import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initialState = { currentAlexState: AlexStates.INACTIVE };

const alexReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.SET_ALEX_STATE:
      return {
        ...state,
        currentAlexState: action.payload,
      };
    default:
      return state;
  }
};

export default alexReducer;
